
function _binarySearch<T>(
	data:T[],
	toValue:(datum:T)=>number,
	v:number,
	ai:number,
	ci:number,
):[number,number]{
	if(ci-ai<=1)
		return [ai,ci];

	const bi=Math.floor((ai+ci)/2);
	if(v<toValue(data[bi])){
		return _binarySearch(data,toValue,v,ai,bi);
	}else{
		return _binarySearch(data,toValue,v,bi,ci);
	}
}

export function binarySearchIndex<T>(
	data:T[],//expected in accending order by value
	toValue:(datum:T)=>number,
	v:number,
):number|undefined{
	if(!data.length)
		return undefined;
	if(v<toValue(data[0]))
		return 0;
	if(toValue(data.at(-1)!)<=v)
		return data.length;
	const [ai,ci]=_binarySearch(data,toValue,v,0,data.length-1);
	const a=toValue(data[ai]);
	const c=toValue(data[ci]);
	return ai+(v-a)/(c-a);
}

export function binarySearch<T>(
	data:T[],//expected in accending order by value
	toValue:(datum:T)=>number,
	v:number,
):[T|null,T|null]{
	if(!data.length)
		return [null,null];
	if(v<toValue(data[0]))
		return [null,data[0]];
	if(toValue(data.at(-1)!)<=v)
		return [data.at(-1)!,null];
	const [ai,ci]=_binarySearch(data,toValue,v,0,data.length-1);
	return [data[ai],data[ci]];
}
